import React from 'react';
import styled from 'styled-components';
import { renderStyledElementStyles } from '../../../../helpers';
import { Paragraph, ParagraphProps } from '../Paragraph';

const StyledDiscountParagraph = styled(Paragraph)`
  ${({ theme }) =>
    renderStyledElementStyles(
      theme,
      theme.module.dStyles.elements.discountParagraph,
    )}
  ${({ theme }) =>
    renderStyledElementStyles(
      theme,
      theme.module.vStyles.elements.discountParagraph,
    )}
`;

export type DiscountParagraphProps = ParagraphProps;

export const DiscountParagraph = ({ text }: DiscountParagraphProps) => (
  <StyledDiscountParagraph text={text} />
);
